import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ReactModal from "react-modal";
import CloseModal from "theme/components/organisms/Modal/CloseModal";
import { H3 } from "theme/components/atoms/Typography/Heading";
import useDelayedIsOpen from "theme/components/organisms/Modal/useDelayedIsOpen";
import { modalOpenedBodyClassName } from "theme/components/organisms/Modal/useBodyFixed";

const Modal = (props) => {
  const [delayedIsOpen, onRequestClose] = useDelayedIsOpen(
    props.isOpen,
    props.onRequestClose,
    300
  );

  const handleAfterOpen = () => {
    // Wait for modal content to be rendered
    setTimeout(() => {
      const modalContent = document.querySelector(".modal__content");
      if (modalContent) {
        const firstInput = modalContent.querySelector(
          "input, textarea, select"
        );
        if (firstInput) {
          firstInput.focus();
        }
      }
    }, 300);
  };

  return (
    <ReactModal
      isOpen={props.isOpen}
      onRequestClose={onRequestClose}
      onAfterOpen={handleAfterOpen}
      className={classnames("modal", {
        [`modal--${props.appearance}`]: props.appearance,
        [`modal--opened`]: delayedIsOpen === true,
        [`modal--closing`]: delayedIsOpen === false,
        [`modal--with-title`]: props.title,
      })}
      overlayClassName={classnames("modal__overlay", {
        [`modal__overlay--${props.appearance}`]: props.appearance,
        [`modal__overlay--opened`]: delayedIsOpen === true,
        [`modal__overlay--closing`]: delayedIsOpen === false,
      })}
      bodyOpenClassName={modalOpenedBodyClassName}
      preventScroll={props.preventScroll}
    >
      <div>
        {!props.dangerouslyIgnoreCloseButton && (
          <CloseModal onClick={onRequestClose} />
        )}
        <div className="modal__content">
          {props.title ? (
            <div className="modal__title">
              <H3>{props.title}</H3>
            </div>
          ) : null}
          <div className="modal__body">{props.children}</div>
          {props.actions ? (
            <div className="modal__actions">{props.actions}</div>
          ) : null}
        </div>
      </div>
    </ReactModal>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  dangerouslyIgnoreCloseButton: PropTypes.bool,
  appearance: PropTypes.oneOf([
    "default",
    "full",
    "full-no-spacing",
    "form",
    "confirmation",
  ]),
  preventScroll: PropTypes.bool,
};

if (typeof window !== "undefined") {
  ReactModal.setAppElement("body");
}

export default Modal;
